import {
  MULTIPLE_CHOICE,
  QUESTION_BACKEND_TYPES
} from "pages/QuestionPage/Constants";

const getQuestionMaxScore = question => {
  return question.question_type === QUESTION_BACKEND_TYPES[MULTIPLE_CHOICE]
    ? question?.can_select_multiple
      ? question.options.reduce((acc, option) => acc + option.value, 0)
      : Math.max(...question.options.map(({ value }) => value))
    : Math.max(...question.bands.map(({ score }) => score));
};

export default getQuestionMaxScore;
